<h5>{{'lang.globals.locationstatus' | translate}}</h5>
<div class="widget mt-4">
  <div class="widget__info">
    <sb-info-text>
      <div class="heading">{{'lang.globals.locations' | translate}}</div>
      <div class="val"><span
        class="blue mr-3">{{(locationData?.onlineStatus?.total ? locationData?.onlineStatus?.total : 0) | sbNumberFormat}}</span>
      </div>
    </sb-info-text>
  </div>
  <div class="widget__info">
    <sb-info-text>
      <div class="heading">{{'lang.globals.locationstatusOnline' | translate}}</div>
      <div class="val"><span
        class="green mr-3">{{(locationData?.onlineStatus?.quotaAllOnline ? locationData?.onlineStatus?.quotaAllOnline : 0)| sbNumberFormat}}</span>
      </div>
    </sb-info-text>
  </div>
  <div class="widget__info">
    <sb-info-text>
      <div class="heading">{{'lang.globals.mixed' | translate}}</div>
      <div class="val"><span
        class="yellow mr-3">{{(locationData?.onlineStatus.total - locationData?.onlineStatus.quotaUnknown) - locationData?.onlineStatus.quotaAllOffline - locationData?.onlineStatus.quotaAllOnline | sbNumberFormat}}</span>
      </div>
    </sb-info-text>
  </div>
  <div class="widget__info">
    <sb-info-text>
      <div class="heading">{{'lang.globals.locationstatusOffline' | translate}}</div>
      <div class="val"><span
        class="red mr-3">{{(locationData?.onlineStatus?.quotaAllOffline ? locationData?.onlineStatus?.quotaAllOffline : 0) | sbNumberFormat}}</span>
      </div>
    </sb-info-text>
  </div>
  <div class="widget__info">
    <sb-info-text>
      <div class="heading">{{'lang.globals.unknown' | translate}}</div>
      <div class="val"><span
        class="grey mr-3">{{(locationData?.onlineStatus?.quotaUnknown ? locationData?.onlineStatus?.quotaUnknown : 0)| sbNumberFormat}}</span>
      </div>
    </sb-info-text>
  </div>
</div>
